// pages/Presentation/sections/IdentityBar.jsx
import React from "react";
import PropTypes from "prop-types";
import { Container, Box } from "@mui/material";
import MKTypography from "components/MKTypography";

export default function IdentityBar({
  accent = "#007849",
  as = "h1",            // <- por padrão vira H1
  maxWidth = "lg",
}) {
  const isH1 = as === "h1";

  return (
    <Box
      component="section"
      sx={{
        py: { xs: 6, md: 3, mb: 4 },
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "4px",
        },
      }}
    >
      <Container maxWidth={maxWidth}>
        <Box
          sx={{
            mx: "auto",
            textAlign: "center",
            maxWidth: 900,
            position: "relative",
            zIndex: 2,
          }}
        >
          {/* Kicker (não faz parte do H1) */}
          <MKTypography
            component="p"
            sx={{
              mb: 1,
              fontSize: { xs: "1rem", md: "1.5rem" },
              letterSpacing: "0.15em",
              textTransform: "uppercase",
              fontFamily: "'Martian Mono', sans-serif",
              color: "#1a202c",
            }}
          >
            Excelência em usinagem
          </MKTypography>

          {/* H1 ou H2/H3 conforme 'as' */}
          <MKTypography
            component={as}
            variant={isH1 ? "h3" : "h4"}   // sem mudar visual, mas com semântica de H1
            sx={{
              fontSize: { xs: "0.9rem", md: "1.2rem" },
              fontFamily: "'Lato', sans-serif",
              lineHeight: 1.6,
              color: "#1a202c",
              m: 0,
              letterSpacing: "0.01em",
              "& .hl": {
                fontWeight: 600,
                position: "relative",
                display: "inline-block",
                "&::after": {
                  content: '""',
                  position: "absolute",
                  bottom: "0px",
                  left: 0,
                  width: "100%",
                  height: "2px",
                  background: `linear-gradient(90deg, ${accent}40, ${accent})`,
                  borderRadius: "2px",
                  transform: "scaleX(0.9)",
                  transition: "transform 0.3s ease",
                },
                "&:hover::after": { transform: "scaleX(1)" },
              },
            }}
          >
            <span className="hl">
              Trabalhamos com usinagem de precisão, dispositivos e moldes
            </span>.
          </MKTypography>
        </Box>
      </Container>
    </Box>
  );
}

IdentityBar.propTypes = {
  accent: PropTypes.string,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
  maxWidth: PropTypes.oneOfType([
    PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
    PropTypes.bool,
  ]),
};
